// SuccessModal.tsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ReservationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  paypayUrl?: string;
}

const ReservationSuccessModal: React.FC<ReservationSuccessModalProps> = ({
  open,
  onClose,
  paypayUrl
}) => {
  const navigate = useNavigate();

  const handlePayment = () => {
    if (paypayUrl) {
      window.open(paypayUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleViewReservations = () => {
    navigate('/reservation/confirm');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="reservation-success-title">
      <DialogTitle id="reservation-success-title">自動予約を受け付けました</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.9 }} gutterBottom>
          指定日時に医院への予約を実行します。まだ医院の予約は確定していません。実行後の結果は予約一覧で確認してください。
        </Typography>
        {paypayUrl && (
          <Typography variant="body2" color="primary" sx={{ mt: 2 }}>
            オンラインでの支払いが可能です。「PayPayで支払う」ボタンをクリックして支払いを完了してください。
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        {paypayUrl && (
          <Button onClick={handlePayment} color="primary" variant="contained">
            PayPayで支払う
          </Button>
        )}
        <Button onClick={handleViewReservations} color="primary" variant="contained">
          予約一覧を見る
        </Button>
        <Button onClick={onClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReservationSuccessModal;
